// Copy for the one-page Financial Model. Every figure in it is calculated
// live; only the framing lives here.

export const modelLead =
  'Your first 12 months, modeled on your own ticket, margin, rep output and retention, with every fee, ad dollar and bonus counted.'

// Go-to-market framing: the year starts with the leader search.
export const modelLeadGoToMarket =
  'Your first year launching door-to-door, starting with an 8-week leader search, modeled on your own numbers with every cost counted.'

// Under the stress test: what "attrition doubled" means.
export const stressDefinition =
  'Attrition doubled: half as many reps survive each stage, so headcount, sales and estimated bonuses halve. Fees and ad spend stay as modeled.'

export const contributionNote =
  'Contribution excludes leader pay and overrides, overhead, insurance, financing and canvassing costs.'
